const venueOptions = [
  { label: "Angel Stadium", value: "1" },
  { label: "AT&T Park", value: "2395" },
  { label: "Busch Stadium", value: "2889" },
  { label: "Chase Field", value: "15" },
  { label: "Citi Field", value: "3289" },
  { label: "Citizens Bank Park", value: "2681" },
  { label: "Comerica Park", value: "2394" },
  { label: "Coors Field", value: "19" },
  { label: "Dodger Stadium", value: "22" },
  { label: "Fenway Park", value: "3" },
  { label: "GABP", value: "2602" },
  { label: "Globe Life Park", value: "13" },
  { label: "Guaranteed Rate Fld", value: "4" },
  { label: "Kauffman Stadium", value: "7" },
  { label: "Marlins Park", value: "4169" },
  { label: "Miller Park", value: "32" },
  { label: "Minute Maid Park", value: "2392" },
  { label: "Nationals Park", value: "3309" },
  { label: "Oakland Coliseum", value: "10" },
  { label: "Oriole Park", value: "2" },
  { label: "Petco Park", value: "2680" },
  { label: "PNC Park", value: "31" },
  { label: "Progressive Field", value: "5" },
  { label: "Rogers Centre", value: "14" },
  { label: "Safeco Field", value: "680" },
  { label: "Salt River", value: "4249" },
  { label: "SunTrust Park", value: "4705" },
  { label: "Target Field", value: "3312" },
  { label: "Tropicana Field", value: "12" },
  { label: "Wrigley Field", value: "17" },
  { label: "Yankee Stadium", value: "3313" }
];

export default venueOptions;



// WEBPACK FOOTER //
// ./src/constants/venueOptions.js